export default {
    account_redesign: {
        // 子账号管理
        sub_account_management: '子账号管理',
        personal_account: '个人账号',
        enterprise_account: '企业账号',
        create_sub_account: '创建子账号',
        manage_scope: '管理范围',
        manage_role: '管理角色',
        username: '用户名',
        email: '邮箱',
        display_name: '显示名称',
        role: '角色',
        scope: '范围',
        status: '状态',
        expire_time: '过期时间',
        create_time: '创建时间',
        active_time: '激活时间',
        operation: '操作',
        edit_role: '编辑角色',
        edit_scope: '编辑范围',
        reinvite: '重新发送邀请',
        delete: '删除',
        unfreeze: '解封',
        invite_validity: '邀请有效期',
        hours_48: '48 小时',
        hours_72: '72 小时',
        all_architecture: '全部组织架构',
        cancel: '取消',
        confirm: '确认',
        create: '创建',
        save: '保存',
        // 创建子账号成功
        create_success: '子账号创建成功',
        initial_password: '初始密码',
        password_show_once_warning: '此密码仅显示一次，请妥善保存',
        first_login_warning: '用户首次登录将强制修改密码',
        invite_expire_warning: '邀请过期后需重新发送',
        download_csv: '下载 CSV',
        send_email_invite: '发送邮件邀请',
        close: '关闭',
        // 范围管理
        scope_management: '范围管理',
        create_scope: '创建范围',
        scope_name: '范围名称',
        associated_architecture: '关联组织架构',
        member_count: '用户数',
        description: '描述',
        edit: '编辑',
        select_architecture: '请选择组织架构节点',
        // Root 转让
        root_transfer: '转让 Root 权限',
        transfer_warning: '转让后，你将失去 Root 权限，降级为普通企业用户。此操作不可撤销。',
        transfer_to: '转让给',
        select_user: '请选择用户',
        transfer_user_tip: '仅显示同企业已激活用户',
        current_root_password: '当前 Root 密码',
        password_confirm_tip: '用于确认身份',
        confirm_transfer: '确认转让',
        transfer_success: '转让成功，原 Root 已冻结',
        // Root 解封
        root_unfreeze: 'Root 解封',
        unfreeze_tip: '解封后，原 Root 用户将恢复为普通企业用户，可为其分配新的角色和范围',
        assign_role: '分配角色',
        assign_scope: '分配范围',
        confirm_unfreeze: '确认解封',
        unfreeze_success: '解封成功',
        // 状态
        status_active: '已激活',
        status_pending: '待激活',
        status_expired: '已过期',
        status_frozen: '冻结',
        status_disabled: '禁用',
        // 提示
        tip_delete_sub_account: '确认删除该UAM账号？删除后该用户将无法登录',
        tip_delete_uam_accounts_batch: '确认删除这些UAM账号？删除后这些用户将无法登录',
        no_role_add: '没有角色？点击添加',
        no_scope_add: '没有范围？点击添加',
        tip_delete_scope: '确认删除该范围？关联的用户将失去该范围的数据访问权限',
        tip_reinvite: '确认重新发送邀请？将生成新的初始密码',
        tip_select_user: '请选择目标用户',
        tip_input_password: '请输入当前 Root 密码',
        // 密码策略
        password_policy_tip: '至少8位，必须包含大写字母+小写字母+数字+特殊符号',
        password_mismatch: '两次输入的密码不一致',
        // 空数据
        no_data: '暂无数据',
        // 第四阶段：安全设置
        security_settings: '安全设置',
        user_list: '用户列表',
        select_users: '请选择用户（可多选）',
        selected_count: '已选 {count} 个用户',
        batch_assign: '批量分配',
        assign_mode: '分配方式',
        mode_overwrite: '覆盖（替换原有角色和范围）',
        mode_append: '追加（在原有基础上添加）',
        permission_preview: '权限预览',
        // 向导式新建账号
        wizard_step_basic: '基本信息',
        wizard_step_role: '角色分配',
        wizard_step_scope: '范围分配',
        wizard_prev: '上一步',
        wizard_next: '下一步',
        company_required: '请选择 Company',
        company_already_has_root: '该 Company 已存在初始账号，一个 Company 只能对应一个初始账号',
        company_id: 'Company ID',
        company_id_placeholder: '请输入企业 ID',
        company_id_required: '请输入企业 ID',
        company_id_not_exist: '企业 ID 不存在',
        create_personal_success: '创建个人账号成功',
        create_enterprise_success: '创建企业账号成功',
        batch_assign_success: '批量分配成功',
        organization: '组织架构',
        company: '企业',
        new_scope: '新增范围',
        edit_scope: '编辑范围',
        organization_required: '请选择组织架构',
        scope_name_required: '请输入范围名称',
        actions: '操作',
        new_personal_account: '新增个人账号',
        edit_personal_account: '编辑个人账号',
        new_enterprise_account: '新增企业账号',
        edit_enterprise_account: '编辑企业账号',
        operate_failed: '操作失败',
        // 第四阶段：企业后台
        enterprise_admin: '企业后台管理',
        company_apply_list: 'Company ID 申请',
        company_list: '企业列表',
        audit_log: '审核记录',
        company_name: '企业',
        contact_name: '联系人',
        contact_mobile: '手机/电话号码',
        contact_email: '邮箱',
        apply_description: '申请说明',
        apply_status: '申请状态',
        apply_time: '申请时间',
        audit_user: '审核人',
        audit_time: '审核时间',
        audit_remark: '审核备注',
        company_id: 'Company ID',
        audit: '审核',
        approve: '通过',
        reject: '驳回',
        status_pending: '待审核',
        status_approved: '已通过',
        status_rejected: '已驳回',
        company: '企业',
        mobile: '手机/电话',
        total_count: '总数',
        active_count: '已激活',
        pending_count: '待激活',
        disabled_count: '已禁用',
        view_detail: '查看详情',
        manage_users: '管理用户',
        activate: '激活',
        disable: '禁用',
        tip_audit_approve: '确认通过该申请？将生成 Company ID',
        tip_audit_reject: '确认驳回该申请？请填写驳回原因',
        audit_failed: '审核失败',
        audit_err_name_conflict: '企业名称已存在，无法审批',
        audit_err_code_conflict: 'Company ID 已存在，无法审批',
        audit_err_email_conflict: '邮箱已存在，无法审批',
        audit_err_phone_conflict: '手机号码已存在，无法审批',
        audit_err_not_found: '申请记录不存在',
        audit_err_already_processed: '该申请已被处理',
        tip_disable_company: '确认禁用该企业？禁用后该企业所有用户将无法登录',
        tip_activate_company: '确认激活该企业？',
        enter_audit_remark: '请输入审核备注',
        uam_account: 'UAM账号',
        enable: '启用',
        disable: '停用',
        pending: '待激活',
        expire: '已过期',
        ok: '确定',
        // 成功创建UAM账号浮动框
        success_create_title: '成功创建UAM账号',
        success_create_body: 'UAM账号创建成功。',
        success_create_warning: '重要提示：这是唯一一次可以查看或下载该用户初始密码（或凭证）的机会。请务必立即保存，否则后续将无法找回。',
        success_create_choose: '请选择以下方式获取凭证：',
        success_create_csv_desc: '下载CSV文件：点击下方按钮，下载包含用户名、密码及登录地址的CSV文件。',
        success_create_show_desc: '显示密码：点击下方按钮，在屏幕上直接查看密码。',
        success_create_security: '安全提醒：请通过安全的方式（如加密邮件、企业内部通讯工具）将凭证分享给对应用户，并提醒用户首次登录后立即修改密码。',
        success_create_48h_warning: '请在 48 小时内使用该账号登录并修改密码，超过 48 小时未激活的账号将自动失效。',
        download_csv_file: '下载 .csv 文件',
        show_password: '显示密码',
        hide_password: '隐藏密码',
        csv_username: '用户名',
        csv_password: '密码',
        csv_login_url: '登录地址',
        // 编辑UAM账号浮动框
        edit_uam_account: '编辑UAM账号',
        // 重新邀请成功浮动框
        reinvite_success_title: 'UAM账号已重新邀请',
        reinvite_success_body: 'UAM账号已重新邀请，新的初始密码已生成。',
        personal_reinvited_title: '个人账号重新邀请成功',
        enterprise_reinvited_title: '企业账号重新邀请成功',
        mobile_phone: '手机/电话号码',
        // 删除确认浮动框
        delete_confirm_title: '删除UAM账号',
        delete_confirm_tip: '此操作不可逆。为防止误操作，请输入该UAM账号的显示名称以确认删除：',
        delete_confirm_placeholder: '请输入显示名称',
        delete_confirm_mismatch: '显示名称不匹配，无法删除',
        delete_confirm_account: '当前账号',
        delete_confirm_display_name: '显示名称',
        // 重新邀请限制
        reinvite_disabled: '已启用的账号无需重新邀请',
        // 重新邀请失败
        reinvite_failed: '重新邀请失败，请稍后重试',
        // Role 权限树
        role_permission: '角色权限',
        // 批量启用/禁用
        batch_disable: '批量禁用',
        batch_enable: '批量启用',
        batch_disable_tip: '确定要禁用选中的UAM账号吗？',
        batch_enable_tip: '确定要启用选中的UAM账号吗？',
        batch_select_empty: '请先勾选要操作的账号',
        // Enterprise Admin 批量操作
        apply: '申请',
        audit_batch: '审核',
        delete: '删除',
        applicant: '申请人',
        auditor: '审批人',
        notify_email: '邮件通知审核结果',
        apply_record_audit: '申请记录审核',
        apply_record_detail: '申请记录信息',
        batch_audit_title: '批量审核',
        batch_audit_tip: '将对选中的 {count} 条记录进行批量审核',
        batch_delete_title: '批量删除',
        batch_delete_tip: '将对选中的 {count} 条记录进行批量删除，此操作不可逆',
        batch_delete_pending_tip: '选中记录中包含未审核的记录，未审核记录不可删除',
        select_at_least_one: '请至少选择一条记录',
        approve_icon: '通过',
        reject_icon: '驳回',
        delete_icon: '删除',
        audit_result: '审核结果',
        audit_remark_placeholder: '请输入审核备注（可选）',
        batch_delete_confirm: '确认删除选中的记录？此操作不可逆',
        apply_form_title: '申请 Company ID',
        apply_form_tip: '填写以下信息提交 Company ID 申请',
        apply_success: '申请提交成功',
        // 安全设置页面
        sec_group_list: '安全分组',
        sec_permissions: '权限',
        sec_group_unit: '个',
        sec_no_group: '暂无分组',
        sec_search_group: '搜索分组名称',
        sec_select_company: '选择企业',
        sec_new_group: '新建分组',
        sec_group_name: '分组名称',
        sec_creator: '创建人',
        sec_assoc_scope: '关联范围',
        sec_assoc_role: '关联角色',
        sec_not_assoc: '未关联',
        sec_tab_basic: '基本信息',
        sec_tab_scope: '范围',
        sec_tab_role: '角色',
        sec_tab_account: '账号',
        sec_select_scope: '请选择范围',
        sec_select_role: '请选择角色',
        sec_scope_tree: '范围组织树',
        sec_role_tree: '角色权限树',
        sec_account_count: '共 {count} 个账号',
        sec_add_account: '添加账号',
        sec_search_account: '搜索账号/用户名',
        sec_col_account: '账号',
        sec_col_mobile: '手机号码',
        sec_col_email: '电子邮箱',
        sec_tip_remove: '确认移除账号 "{name}"？',
        sec_tip_select_group: '请从左侧选择一个分组',
        sec_input_group_name: '请输入分组名称',
        sec_input_desc: '请输入描述',
        sec_select_company_required: '请选择企业',
        sec_create_success: '创建成功',
        sec_save_success: '保存成功',
        sec_remove_success: '已移除',
        sec_add_success: '成功添加 {count} 个账号',
        sec_assoc_scope_success: '关联范围成功',
        sec_assoc_role_success: '关联角色成功',
        sec_unassoc_success: '已取消关联',
        sec_add_account_title: '添加账号',
        sec_add_btn: '添加',
        sec_search_btn: '搜索',
        sec_created_at: '{time} 创建',
        sec_company_label: '企业：{name}',
        sec_save_failed: '保存失败',
        sec_create_failed: '创建失败',
        sec_add_failed: '添加失败',
        sec_remove_failed: '移除失败',
        sec_operate_failed: '操作失败',
        // User Profile 改造
        up_basic_info: '基本信息',
        up_functions: '功能',
        up_active: '活跃',
        up_edit_profile: '编辑资料',
        up_res_desc: '查看可访问菜单、角色与权限',
        up_pwd_desc: '修改当前账号登录密码',
        up_sig_desc: '编辑或重新绘制手写签名',
        up_unit_desc: '温度数据展示单位（°C / °F / K）',
        up_locate: '定位',
        up_locate_desc: '在地图上查看企业或个人空间的位置',
        up_locate_no_data: '当前账号暂无位置数据',
        up_sig_set: '已设置',
        up_sig_not_set: '未设置',
        up_items: '项',
        up_avatar_too_large: '上传图片大小不能超过 2MB',
        up_avatar_format: '上传图片只能是 JPG、JPEG、BMP、PNG 格式',
        up_mobile_phone: '手机/电话号码',
        up_company_id: 'Company ID',
        up_personal_space: '个人空间',
        up_apply_enterprise: '申请企业账号',
        up_apply_enterprise_desc: '将个人账号升级为企业账号',
        up_root_transfer: '初始账号切换',
        up_root_transfer_desc: '将初始账号权限转让给其他用户',
        up_change_email: '修改邮箱',
        up_email_readonly: '仅企业初始账号可修改邮箱',
        up_email_same_as_current: '新邮箱不能与当前邮箱相同',
        up_email_change_desc: '验证密码后通过验证码修改邮箱',
        up_email_change_new_email: '新邮箱',
        up_email_change_password: '当前密码',
        up_email_change_tip: '验证码将发送到新邮箱，有效时间5分钟',
        up_email_verify_title: '邮箱验证',
        up_email_verify_code: '验证码',
        up_email_verify_tip: '验证码已发送到 {email}，有效时间5分钟',
        up_email_resend: '重新发送',
        up_email_resend_wait: '{s}秒后可重新发送',
        up_email_verify_success: '邮箱修改成功',
        up_email_verify_fail: '验证失败',
        up_email_code_sent: '验证码已发送',
        up_email_sending: '正在发送验证码',
        up_email_sending_tip: '正在向 {email} 发送验证码，请稍候...',
        up_email_send_failed: '发送失败',
        up_email_send_failed_tip: '验证码发送失败，请返回个人中心重新申请',
        up_email_no_pending: '没有待验证的邮箱变更请求，请从个人中心重新申请',
        up_email_back_to_profile: '返回个人中心',
        up_apply_enterprise_title: '申请企业账号',
        up_apply_enterprise_tip: '升级后您的账号将变为企业初始账号，此操作不可撤销',
        up_apply_company_name: '企业名称',
        up_apply_company_code: 'Company ID',
        up_apply_email: '邮箱',
        up_apply_mobile: '手机号码',
        up_apply_password: '当前密码',
        up_apply_confirm: '确认升级',
        up_apply_success: '升级成功，请重新登录',
        up_apply_company_code_exists: '该企业ID已被使用，请更换',
        up_apply_company_available: '企业ID可用',
        up_apply_company_not_exist: '企业ID不存在，请先申请',
        up_root_transfer_title: '初始账号切换',
        up_transfer_to: '转让给',
        up_select_user: '请选择用户',
        up_current_password: '当前密码',
        up_confirm_transfer: '确认转让',
        up_transfer_warning: '转让后当前账号将被冻结，此操作不可撤销',
        up_transfer_success: '转让成功'
    }
}
